import React from 'react';
import { PrivacyMode } from '../../types/common';

interface PrivacyBadgeProps {
    mode?: PrivacyMode;
    className?: string;
    showLabel?: boolean;
    compact?: boolean;
    isMember?: boolean;
}

export const PrivacyBadge: React.FC<PrivacyBadgeProps> = ({
    mode = 'open',
    className = '',
    showLabel = true,
    compact = false,
    isMember = false
}) => {
    // Member overrides everything else
    if (isMember) {
        if (compact) {
            return (
                <div className={`flex items-center justify-center w-6 h-6 rounded-full bg-success/10 border border-success/20 ${className}`} title="Vous êtes membre">
                    <span className="material-symbols-outlined text-[14px] text-success font-bold" style={{ fontVariationSettings: "'FILL' 0, 'wght' 700, 'GRAD' 0, 'opsz' 24" }}>
                        lock_open_right
                    </span>
                </div>
            );
        }

        return (
            <div className={`flex items-center gap-1.5 px-2 py-0.5 rounded-md border bg-success/10 border-success/20 ${className}`} title="Vous êtes membre">
                <span className="material-symbols-outlined text-sm text-success font-bold" style={{ fontVariationSettings: "'FILL' 0, 'wght' 700, 'GRAD' 0, 'opsz' 24" }}>
                    lock_open_right
                </span>
                {showLabel && (
                    <span className="text-[10px] font-bold uppercase text-success">
                        Membre
                    </span>
                )}
            </div>
        );
    }

    const config = {
        open: {
            icon: 'public',
            label: 'Public',
            color: 'text-success',
            bg: 'bg-success/10 border-success/20',
            fullLabel: 'Groupe Public'
        },
        request: {
            icon: 'how_to_reg',
            label: 'Sur demande',
            color: 'text-warning',
            bg: 'bg-warning/10 border-warning/20',
            fullLabel: 'Sur demande'
        },
        invite: {
            icon: 'lock',
            label: 'Fermé',
            color: 'text-danger',
            bg: 'bg-danger/10 border-danger/20',
            fullLabel: 'invitation seulement'
        },
        locked: {
            icon: 'key',
            label: 'Verrouillé',
            color: 'text-purple-400',
            bg: 'bg-purple-500/10 border-purple-500/20',
            fullLabel: 'Mot de passe'
        }
    };

    const currentConfig = config[mode] || config.open;

    if (compact) {
        return (
            <div className={`flex items-center justify-center w-6 h-6 rounded-full ${currentConfig.bg} border ${className}`} title={currentConfig.fullLabel}>
                <span className={`material-symbols-outlined text-[14px] ${currentConfig.color}`}>
                    {currentConfig.icon}
                </span>
            </div>
        );
    }

    return (
        <div className={`flex items-center gap-1.5 px-2 py-0.5 rounded-md border ${currentConfig.bg} ${className}`} title={currentConfig.fullLabel}>
            <span className={`material-symbols-outlined text-sm ${currentConfig.color}`}>
                {currentConfig.icon}
            </span>
            {showLabel && (
                <span className={`text-[10px] font-bold uppercase ${currentConfig.color}`}>
                    {currentConfig.label}
                </span>
            )}
        </div>
    );
};
